import * as React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import Moment from 'react-moment';

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    bgcolor: "background.paper",
    border: "none",
    outline: "none",
    boxShadow: 24,
    p: 4,
};

const UserRow = ({ title, value }) => {
    return (
        <div className="">
            <big>{title}: </big>
            {title.startsWith("CreatedAt") ? (
                <Moment>{value}</Moment>
            ) : (
                <span>{value}</span>
            )}
        </div>
    )
}

export default function UserDetails({ user }) {
    React.useEffect(() => {
        handleOpen();
    }, []);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div>
                        <h3>User Details</h3>
                        <hr />
                        <UserRow title="Names" value={user?.Names} />
                        <UserRow title="Account type" value={user?.AccountType} />
                        <UserRow title="Email" value={user?.Email} />
                        <UserRow title="plan" value={user?.plan} />
                        <UserRow title="Last Login" value={user?.LastLogin} />
                        <UserRow title="lastPayment" value={user?.lastPayment ? user?.lastPayment : "none"} />
                        <UserRow title="isVerified" value={user?.isVerified.toString()} />
                        <UserRow title="Downloads" value={user?.downloads} />
                        <UserRow title="Created At" value={user?.CreatedAt} />
                        {/* <UserRow title="profileBackgroundColor" value={user?.profileBackgroundColor} /> */}
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
